import React from "react";

const LoadingScreen = () => {
  return (
    <div
      className="d-flex flex-column align-items-center justify-content-center px-4"
      style={{ height: "80vh" }}
    >
      <div className="spinner-border text-azure" role="status"></div>
    </div>
  );
};

export default LoadingScreen;
